module.exports = __webpack_public_path__ + "static/img/LU.888b991a.jpg";